export default function TestOutput({
  children,
}: {
  children: React.ReactNode | React.ReactNode[]
}) {
  return <div className="bg-(--bg-color-dim) my-6 rounded-lg">{children}</div>
}
